import { ListenerOptions } from "@angular/core";
import { EventManagerPlugin } from "@angular/platform-browser";

export class CaptureEventPlguin extends EventManagerPlugin {
  override supports(eventName: string): boolean {
    return eventName.startsWith("click.capture");
  }
  override addEventListener(element: HTMLElement, eventName: string, handler: Function, options?: ListenerOptions): Function {
    const [event] = eventName.split(".");

    const listener = (event: Event) => handler(event);

    element.addEventListener(event, listener, { capture: true });

    return this.manager.addEventListener(element, event, handler(event), { capture: true });
  }
}
